export default class VideoProducerModel {
  constructor(dataJson) {
    this.dataJson = dataJson;
    if (typeof dataJson === 'undefined') {
      this.dataJson = {};
    }

    this.markers = this.getMarkers();
    this.initialProgress();
    this.urlVideo = this.getUrlVideo();
    this.thumbnail = this.getThumbnail();
    this.markerSelected = {};
    const totalTime =
      this.markers.length > 0 ? this.markers[this.markers.length - 1].endTime / 2 : 0;
    const startimeMarkers = this.markers.map((item) => item.startTime);
    // buscamos la marca de tiempo que está mas cerca de la mitad de la duración del vídeo
    this.midpointMarker = startimeMarkers.find((item) => item >= totalTime / 2);
  }

  getUrlVideo() {
    return this.dataJson.video || '';
  }

  getThumbnail() {
    return this.dataJson.thumbnail || '';
  }

  getMarkers() {
    return this.dataJson.markers || [];
  }

  setMarkerSelectedBySec(sec) {
    this.updateProgressValue(sec);
    if (!this.secInrange(sec)) {
      if (typeof this.markers === 'undefined') return {};

      const results = this.markers.filter((item) => sec >= item.startTime && sec <= item.endTime);
      if (typeof results !== 'undefined' && Array.isArray(results)) {
        if (results.length > 0) {
          [this.markerSelected] = results;
        } else {
          this.markerSelected = {};
        }
      } else {
        this.markerSelected = {};
      }
    }
    return this.markerSelected.url;
  }

  secInrange(sec) {
    if (sec !== this.secondSelected) {
      this.secondSelected = sec;
      if (
        typeof this.markerSelected.startTime === 'undefined' ||
        typeof this.markerSelected.endTime === 'undefined'
      ) {
        return false;
      }
      if (sec >= this.markerSelected.startTime && sec <= this.markerSelected.endTime) {
        return true;
      }
    }
    return false;
  }

  initialProgress() {
    // eslint-disable-next-line array-callback-return
    this.markers.map((item) => {
      const progress = {};
      progress.value = 0;
      progress.max = item.endTime - item.startTime;
      // eslint-disable-next-line no-param-reassign
      item.progress = progress;
    });
  }

  updateProgressValue(sec) {
    // eslint-disable-next-line array-callback-return
    this.markers.map((item) => {
      if (sec >= item.startTime && sec <= item.endTime) {
        const progresvalue = Math.abs(item.startTime - sec);
        // eslint-disable-next-line no-param-reassign
        item.progress.value = progresvalue > 0 ? Math.ceil(progresvalue) : 0;
      }
    });
  }
}
